/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { centerAbsolutely, fullSize } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BACKGROUND STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	background: {
		extend: [centerAbsolutely, fullSize],
		zIndex: '1',
		// opacity: '0',
		// animationName: 'fadeIn',
		// animationDelay: '0s',
		// animationDuration: '.3s',
		// animationFillMode: 'forwards',
		'&.bgContentType-marketResearch': {
			'& .image': { backgroundImage: `url(${url.image.app}/photo-survey.jpg) !important` },
			'& .fade': { background: 'rgba(18,18,18,0.1) !important' },
            '&.abTestVersion-QUALIFIED-1, &.abTestVersion-UNLOCKED, &.abTestVersion-QUALIFIED-2, &.abTestVersion-COUNTDOWN':{
                '& .image':{
                    backgroundImage: 'none !important'
				}
            },
			'&.abTestVersion-EMOJI, &.abTestVersion-QUESTION':{
				'& .image':{
					backgroundImage: `url(${url.image.app}/graphic-glasses-images.png) !important`
				}
			}
		}
	},
	fade: {
		extend: [centerAbsolutely, fullSize],
		zIndex: '2',
		// this is automatically overwritten in the component itself via content data (each frame can have custom color and opacity)
		// helpful gradient generator below
		// http://angrytools.com/gradient/
		// background: "radial-gradient(ellipse at center, rgba(82,83,84,0.65) 0%, rgba(0,10,10,0.7) 100%)" /* w3c */

	},
	image: {
		transition: 'background-image .5s ease-in 0s',
		extend: [centerAbsolutely, fullSize],
		zIndex: '1',
		backgroundColor: '#000',
		backgroundPosition: '50% 50%',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover'
		// backgroundImage added dynamically as inline style from component file which pulls it from content data
	}
};